import { prepareTimerangeQuery } from 'utils/pql';

import useSearchAlternated from './useSearchAlternated';

const useGetMoreEntityDetails = ({ t0, t1, entity, side }) => {
  const sensorId = entity.sensorId;

  // this only makes sense for internal IPs, and undefined query will skip the search
  const pqlQuery =
    entity.type === 'internal_ip'
      ? `${prepareTimerangeQuery(t0, t1)} (ip = "${entity.entity}" or client_addr = "${entity.entity}") AND`
      : undefined;
  const hostnameSearch = useSearchAlternated({
    pqlQuery,
    pqlAlternation: `(hostname like /.+/ or host_name like /.*/) | countby hostname, host_name`,
    searchType: 'O_SENSOR',
    context: [sensorId],
  });
  const macAddressSearch = useSearchAlternated({
    pqlQuery,
    pqlAlternation: `log = "conn" | countby ${side === 'source' ? 'orig_l2_addr' : 'resp_l2_addr'}`,
    searchType: 'O_SENSOR',
    context: [sensorId],
  });

  const hostnameItem = hostnameSearch?.results?.[0]?.key;

  return {
    isLoading: pqlQuery && (hostnameSearch.loading || macAddressSearch.loading),
    error: hostnameSearch.error || macAddressSearch.error,
    hostname: hostnameItem ? hostnameItem['data.hostname'] || hostnameItem['data.host_name'] : undefined,
    macAddresses: macAddressSearch?.results?.map((r) => r.key),
  };
};

export default useGetMoreEntityDetails;
